import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { useLanguage } from "@/context/LanguageContext";
import { ABOUT_NAV } from "@/data/about";

export const Footer = () => {
  const { lang, t } = useLanguage();
  const links = [
    { to: "/", label: t.nav.home, testid: "footer-link-home" },
    { to: "/chi-siamo", label: ABOUT_NAV[lang], testid: "footer-link-about" },
    { to: "/adv", label: t.nav.adv, testid: "footer-link-adv" },
    { to: "/digital", label: t.nav.digital, testid: "footer-link-digital" },
    { to: "/corporate", label: t.nav.corporate, testid: "footer-link-corporate" },
    { to: "/ai", label: t.nav.ai, testid: "footer-link-ai" },
    { to: "/video-clip", label: t.nav.videoclip, testid: "footer-link-videoclip" },
    { to: "/news", label: "News", testid: "footer-link-news" },
    { to: "/contatti", label: t.nav.contact, testid: "footer-link-contact" },
    { to: "/privacy", label: "Privacy", testid: "footer-link-privacy" },
    { to: "/cookie-policy", label: "Cookie Policy", testid: "footer-link-cookies" },
  ];

  return (
    <footer className="border-t border-white/10 bg-[#08080A]" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <Logo />
          <p className="mt-6 text-slate-400 text-sm leading-relaxed max-w-md" data-testid="footer-blurb">
            {t.footer.blurb}
          </p>
        </div>
        <div className="md:col-span-3">
          <h4 className="f-mono text-[11px] uppercase tracking-[0.25em] text-red-500 mb-5">{t.footer.nav}</h4>
          <ul className="space-y-3">
            {links.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={l.testid} className="text-sm text-slate-400 hover:text-slate-100 transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <h4 className="f-mono text-[11px] uppercase tracking-[0.25em] text-red-500 mb-5">{t.footer.contactTitle}</h4>
          <ul className="space-y-4 text-sm text-slate-400">
            <li className="flex items-start gap-3">
              <MapPin size={15} className="mt-0.5 text-slate-500 shrink-0" />
              <span data-testid="footer-address">Via U. Braschi 8, 47822 Santarcangelo di Romagna (RN) · Italia</span>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={15} className="mt-0.5 text-slate-500 shrink-0" />
              <a href="mailto:info@rvfilm.it" data-testid="footer-email" className="hover:text-slate-100 transition-colors">
                info@rvfilm.it
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="f-mono text-[10px] tracking-[0.2em] text-slate-600" data-testid="footer-rights">{t.footer.rights}</p>
          <p className="f-mono text-[10px] tracking-[0.2em] text-slate-600">ADV · DIGITAL · CORPORATE · AI</p>
        </div>
      </div>
    </footer>
  );
};
